import React from "react";

const Transportation = () => {
  return (
    <section className="w-full bg-[#e2e3e5] px-4 py-14">
      <div className="mx-auto max-w-5xl text-left">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Reliable Goods Transportation Services in Delhi
        </h2>

        <p className="text-sm text-gray-600 leading-6 mb-4">
          The vibrant city of Delhi is home to several businesses and
          individuals who require efficient transportation services throughout
          the year. Porter provides easy pickup and transportation services in
          Delhi, letting you reliably send consignments across the city.
        </p>

        <p className="text-sm text-gray-600 leading-6 mb-4">
          If you're also seeking smooth & efficient transportation of goods in
          Delhi, you're at the right place. At Porter, we make it easy to send
          goods in Delhi — be it gifts, tiffins, or product samples — with our
          reliable end-to-end transportation service at economical prices.
        </p>

        <p className="text-sm text-gray-600 leading-6 mb-6">
          You can book our on-demand consignment transportation service within
          minutes to fulfill goods transportation. We will assign a
          driver-partner for quick pickup and consignment transportation.
        </p>

        <h3 className="text-md font-semibold text-gray-800 mb-2">
          Choose Porter for consignment transportation Services in Delhi
        </h3>

        <ol className="list-decimal pl-5 text-sm text-gray-600 leading-6 space-y-2 mb-6">
          <li>
            <span className="font-semibold">Cost-effective:</span> Porter’s
            economically priced consignment transportation in Delhi will allow
            you to enjoy reliable services without exceeding your budget.
          </li>
          <li>
            <span className="font-semibold">Reliable:</span> Our reliable bike
            consignment transportation service lets you book and send goods in
            Delhi in just a few minutes.
          </li>
          <li>
            <span className="font-semibold">Efficient:</span> We provide
            dependable services for on-demand transportation with added
            convenience of ETA tracking.
          </li>
        </ol>

        <h3 className="text-md font-semibold text-gray-800 mb-2">
          How to Send Consignments Online in Delhi?
        </h3>

        <ol className="list-decimal pl-5 text-sm text-gray-600 leading-6 space-y-2">
          <li>Open the Porter app and choose Two-Wheelers</li>
          <li>Enter your pickup and drop addresses</li>
          <li>Add stops if needed</li>
          <li>Choose goods type</li>
          <li>Select payment method</li>
          <li>Apply coupons if available</li>
        </ol>
      </div>
    </section>
  );
};

export default Transportation;
